import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Facebook Logo" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("polygon", { points: "0.00140625 0.0009375 24 0.0009375 24 23.8542187 0.00140625 23.8542187" }) }),
		/* @__PURE__ */ _jsx("g", {
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "f_logo_RGB-Blue_1024-Copy",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group-3",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M24,12 C24,5.37257813 18.6274219,0 12,0 C5.37257813,0 0,5.37257813 0,12 C0,17.9895469 4.38822656,22.9539844 10.125,23.8542188 L10.125,15.46875 L7.078125,15.46875 L7.078125,12 L10.125,12 L10.125,9.35625 C10.125,6.34875 11.9165156,4.6875 14.6575781,4.6875 C15.9704766,4.6875 17.34375,4.921875 17.34375,4.921875 L17.34375,7.875 L15.8305781,7.875 C14.3398828,7.875 13.875,8.80000781 13.875,9.74899219 L13.875,12 L17.203125,12 L16.6710938,15.46875 L13.875,15.46875 L13.875,23.8542188 C19.6117734,22.9539844 24,17.9895469 24,12",
						id: "Fill-1",
						fill: "#1877F2",
						mask: "url(#mask-2)"
					})
				}), /* @__PURE__ */ _jsx("path", {
					d: "M16.6710938,15.46875 L17.203125,12 L13.875,12 L13.875,9.74899219 C13.875,8.80000781 14.3398828,7.875 15.8305781,7.875 L17.34375,7.875 L17.34375,4.921875 C17.34375,4.921875 15.9704766,4.6875 14.6575781,4.6875 C11.9165156,4.6875 10.125,6.34875 10.125,9.35625 L10.125,12 L7.078125,12 L7.078125,15.46875 L10.125,15.46875 L10.125,23.8542187 C10.7359453,23.9500781 11.362125,24 12,24 C12.637875,24 13.2640547,23.9500781 13.875,23.8542187 L13.875,15.46875 L16.6710938,15.46875",
					id: "Fill-4",
					fill: "#FFFFFF"
				})]
			})
		})
	]
});
export default SvgFacebookLogo;
